import dayjs from "dayjs";

export function hasResourceOrderPeriod(start: string | null, end: string | null): boolean {
  return !!start || !!end;
}

export function formatResourceOrderPeriod(start: string | null, end: string | null): string | null {
  const format = (date: string) => dayjs(date).format("dd., DD.MM.YYYY");
  if (start && end) return `${format(start)} - ${format(end)}`;
  if (start) return `ab ${format(start)}`;
  if (end) return `bis ${format(end)}`;
  return null;
}
